// Libs
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

// Components
import { BlogCard } from "../../components/BlogCard/BlogCard";
import { LoadingFallback } from "../../components/LoadingFallback/LoadingFallback";
import { View } from "../../containers/view/View";
import { Blog } from "../../models/Blog";

// Utils
import api from "../../api";
import styles from "./ConsultingPage.module.scss";
import { previewImage } from "../../constants";

export const ConsultingPage: React.FunctionComponent = () => {
  const [posts, setPosts] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const response = await api.blogs.fetchBlogs("3");
      const data = await response.json();
      if (response.status === 200) {
        setPosts(data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  return (
    <View
      title="Poslovno savjetovanje"
      description="Iskoristite naše bogato iskustvo stečeno u praktičnom rješavanju problema na tržištu rada u organizacijama različitih branši."
    >
      <Helmet>
        <title>Poslovno savjetovanje | Agencija Spektar</title>
        <meta name="description" content="Agencija Spektar" />
        <meta
          property="og:title"
          content="Poslovno savjetovanje | Agencija Spektar"
        />
        <meta property="og:image" content={previewImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Agencija Spektar" />
      </Helmet>

      <View.Content>
        <div className={styles.cards}>
          {loading && <LoadingFallback />}
          {!loading && posts.length === 0 ? (
            <p className={styles.center}>Nisu pronađeni članci.</p>
          ) : (
            posts.map((e) => {
              return <BlogCard blog={e} key={e.id} />;
            })
          )}
        </div>
      </View.Content>
    </View>
  );
};
